





















import { computed, defineComponent, ref } from "@vue/composition-api";
import { Location } from "vue-router";
import { Page } from "@scrile/api-provider/dist/api/PageProvider";
import providers from "@/lib/api";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "ComplianceContactsInfo",
  components: { BaseSpinner },
  setup() {
    const loading = ref(false);
    const pages = ref<Page[]>([]);
    const contactsPage = computed(() => pages.value.find(page => page.path === "/static/contact-us.html"));
    const isContactsPageVisible = computed(() => contactsPage.value?.visible ?? false);
    const contactsPageLink = computed(() => contactsPage.value?.path);
    const supportLink: Location = {
      name: "messages",
      params: {
        userId: "1",
      },
    };

    const getPages = async () => {
      try {
        loading.value = true;
        pages.value = await providers.PageProvider.find();
      } finally {
        loading.value = false;
      }
    };

    getPages();
    return { isContactsPageVisible, contactsPageLink, supportLink, loading };
  },
});
